import { useState } from "react";

export default function EventImage({ src, alt, className = "", testId }) {
  const [zoom, setZoom] = useState(false);
  return (
    <>
      <img
        src={src}
        alt={alt}
        onClick={() => setZoom(true)}
        data-testid={testId}
        className={`${className} cursor-zoom-in hover:shadow-lg hover:scale-[1.02] transition-all duration-200`}
      />
      {zoom && (
        <div
          className="fixed inset-0 z-50 bg-slate-900/90 backdrop-blur-sm flex items-center justify-center p-4 cursor-zoom-out"
          onClick={() => setZoom(false)}
          role="dialog"
          aria-modal="true"
          aria-label={alt}
          data-testid={`${testId}-lightbox`}
        >
          <img src={src} alt={alt} className="max-h-[90vh] max-w-[92vw] object-contain rounded-2xl shadow-2xl" />
          <p className="absolute bottom-6 text-white/80 text-sm">Cliquez n'importe où pour fermer</p>
        </div>
      )}
    </>
  );
}
